module.exports = __webpack_public_path__ + "media/images/dummy-content/user-1-381bf01064b8122aceb1a08ee6a5f1f2.jpg";